import React, { useState } from "react";
import { Box, Typography, Link, Grid, IconButton } from "@mui/material";
import { motion } from "framer-motion";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const Footer = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <motion.div
      animate={{ height: expanded ? "auto" : "60px" }}
      transition={{ duration: 0.4 }}
      style={{
        overflow: "hidden",
        backgroundColor: "#f9fafb",
        borderTop: "1px solid #e5e7eb",
        position: "relative",
      }}
    >
      {/* Drag / Toggle Arrow */}
      <Box
        sx={{
          position: "absolute",
          top: 8,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 10,
          bgcolor: "white",
          borderRadius: "50%",
          boxShadow: 2,
        }}
      >
        <IconButton onClick={() => setExpanded(!expanded)} size="small">
          {expanded ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
        </IconButton>
      </Box>

      {/* Footer Content */}
      <Box
        sx={{
          mt: expanded ? 5 : 0,
          py: expanded ? 4 : 2,
          px: { xs: 2, sm: 6 },
          textAlign: "center",
          transition: "padding 0.3s ease",
        }}
      >
        {expanded ? (
          <>
            {/* Footer Sections */}
            <Grid
              container
              spacing={3}
              justifyContent="center"
              sx={{ mb: 3, textAlign: { xs: "center", sm: "left" } }}
            >
              <Grid item xs={12} sm={2.5}>
                <Typography variant="subtitle1" fontWeight="bold">
                  About Us
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  PluggI™ connects students and communities by promoting
                  collaboration, sharing, and creativity.
                </Typography>
              </Grid>

              <Grid item xs={12} sm={2.5}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Contact
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Reach us at:{" "}
                  <Link href="mailto:contact@pluggi.ca" underline="hover">
                    contact@pluggi.ca
                  </Link>
                </Typography>
              </Grid>

              <Grid item xs={12} sm={2.5}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Privacy Policy
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Learn how we protect your data and privacy on PluggI™.
                </Typography>
              </Grid>

              <Grid item xs={12} sm={2.5}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Terms of Service
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Read our guidelines and user responsibilities.
                </Typography>
              </Grid>

              <Grid item xs={12} sm={2.5}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Help / Support
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Visit our FAQ or support page for assistance.
                </Typography>
              </Grid>
            </Grid>

            {/* Bottom Line */}
            <Typography variant="body2" color="text.secondary">
              © {new Date().getFullYear()} PluggI™. All rights reserved.
            </Typography>
            <Typography variant="caption" color="text.secondary">
              PluggI™ is a trademark of Kenneth Nnah.
            </Typography>
          </>
        ) : (
          // Collapsed mode (simple mini footer)
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mt: 2, opacity: 0.8 }}
          >
            © {new Date().getFullYear()} PluggI™
          </Typography>
        )}
      </Box>
    </motion.div>
  );
};

export default Footer;
